export default __webpack_public_path__ + "static/media/bottom_every.05d97fb6.png";